<template>
  <div class="index-page" :style="{marginTop: $store?.state?.isVisitor ? '54px' : '100px'}">
    <div class="index-page-select-bg"></div>
    <div class="index-content">
      <!--价格查询-->
      <div class="index-price-select">
        <div class="index-price-select_title">
          {{ $t('ContainerLeasingPriceQuery') }}
          <span class="index-price-select_title_button" @click="$router.push('/order/quotationList')">{{
              $t('viewAllPrize')
            }}<a-icon type="right"/></span>
        </div>
        <div class="index-price-select_button">
          <div class="index-price-select_button_left">
            <div class="index-price-select_button_left_city">
              <div class="index-price-select_button_left_city_title">{{ $t('takeBoxPlace') }}</div>
              <div class="index-price-select_button_left_city_button">
                <dol-select
                    style="font-size: 18px"
                    width="240px"
                    v-model="quotedForm['CITY_IDS']"
                    source="local"
                    :defaultData="leftCityOption"
                    dot-net-table-name="GM_CITY"
                    :label-field="$kt('CITY_NAME')"
                    key-field="CITY_ID"
                    value-field="CITY_ID"
                    @change="(val, data) => beforeGetData(val, data, true)"
                    ref="city"
                />
              </div>
            </div>
            <div class="index-price-select_button_left_d_city">
              <div style="margin-left: 10px">
                <div class="index-price-select_button_left_d_city_title">{{ $t('通用_还箱地') }}</div>
                <div class="index-price-select_button_left_d_city_button">
                  <dol-select
                      style="font-size: 18px"
                      width="240px"
                      v-model="quotedForm['D_CITY_IDS']"
                      source="local"
                      :defaultData="rightCityOption"
                      dot-net-table-name="GM_CITY"
                      :label-field="$kt('CITY_NAME')"
                      key-field="CITY_ID"
                      value-field="CITY_ID"
                      @change="(val, data) => beforeGetData(val, data, false)"
                      ref="city"
                  />
                </div>
              </div>
            </div>
            <img class="index-price-select_button_img" src="../../public/static/icon/change.svg" @click="changeCity">
          </div>
          <div class="index-price-select_button_right">
            <div class="index-price-select_button_right_title">{{ $t('通用_箱型') }}</div>
            <select-box-size v-model="quotedForm.BOX_SIZE" ref="boxSelect"/>
          </div>
        </div>
        <div class="index-price-select_submit_button" @click="searchPrice()">
          <a-icon type="search" style="padding-right: 6px"/>
          {{ $t('search') }}
        </div>
      </div>
      <div class="index-price-select-result" v-if="quotedPrice">
        <div class="index-price-select-result_title">{{ $t('queryResults') }}<span>{{ quotedPrice?.length }} {{
            $t('matchingResults')
          }}</span></div>
        <template v-if="quotedPrice?.length > 0">
          <div v-for="item in quotedPrice" :key="item.FLOW_ID" class="index-price-select-result_box">
            <img class="index-price-select-result_box_img" src="../../public/static/icon/box.svg">
            <a-row class="index-price-select-result_box_content">
              <a-col class="index-price-select-result_box_content_col" :span="6">
                <div class="index-price-select-result_box_content_col_svg">
                  <img src="../../public/static/icon/luxian.svg">
                </div>
                <div class="index-price-select-result_box_content_col_city">
                  <div>{{ $dt(item, 'CITY_NAME') }}</div>
                  <div>{{ $dt(item, 'D_CITY_NAME') }}</div>
                </div>
              </a-col>
              <a-col class="index-price-select-result_box_content_col" :span="6">
                <div class="index-price-select-result_box_content_col_2">
                  <div class="index-price-select-result_box_content_col_2_top">{{ $t('通用_箱型') }}</div>
                  <div class="index-price-select-result_box_content_col_2_bottom">{{ $dt(item, 'BOX_SIZE_NAME') }}</div>
                </div>
              </a-col>
              <a-col class="index-price-select-result_box_content_col" :span="6">
                <div class="index-price-select-result_box_content_col_2">
                  <div class="index-price-select-result_box_content_col_2_top">{{ $t('boxStatus') }}</div>
                  <div class="index-price-select-result_box_content_col_2_bottom">{{
                      $dt(item, 'BOX_STATE_NAME')
                    }}
                  </div>
                </div>
              </a-col>
              <a-col class="index-price-select-result_box_content_col" :span="6">
                <div class="index-price-select-result_box_content_col_4">
                  <div class="index-price-select-result_box_content_col_4_top">{{ $t('通用_价格') }}</div>
                  <div class="index-price-select-result_box_content_col_4_hide" v-if="$store.state?.isVisitor">***</div>
                  <div v-else class="index-price-select-result_box_content_col_4_bottom">
                    <span v-if="item.PROM_PRICE && item.IS_CBC && item.ROUTE_QTY > 0">
                        <span v-if="item.PROM_PRICE < 0" style="color: #FF6F27;font-size: 12px;">{{
                            $t('subsidy')
                          }}</span>${{ Math.abs(item.PROM_PRICE) }}
                    </span>
                    <span v-else-if="item.IS_CBC">
                      {{ $t('cassByCass') }}
                    </span>
                    <div v-else>
                      <span v-if="item.PROM_PRICE && !item.IS_CBC && item.VALID_PRICE && item.ROUTE_QTY > 0"
                            style="text-decoration: line-through;color: #333333">
                        <span v-if="item.VALID_PRICE < 0" style="color: #FF6F27;font-size: 12px;">{{
                            $t('subsidy')
                          }}</span>${{ Math.abs(item.VALID_PRICE) }}
                      </span>
                      <span v-if="item.PROM_PRICE && item.ROUTE_QTY > 0" style="color: #FF6F27">
                        <span v-if="item.PROM_PRICE < 0" style="color: #FF6F27;font-size: 12px;">{{
                            $t('subsidy')
                          }}</span>${{ Math.abs(item.PROM_PRICE) }}
                      </span>
                      <span v-else-if="item.VALID_PRICE">
                        <span v-if="item.VALID_PRICE < 0" style="color: #FF6F27;font-size: 12px;">{{
                            $t('subsidy')
                          }}</span>${{ Math.abs(item.VALID_PRICE) }}
                      </span>
                    </div>
                  </div>
                </div>
              </a-col>
            </a-row>
            <div class="index-price-select-result_box_button">
              <div class="index-price-select-result_box_button_style" @click="applyBox(item,20391001)">
                {{ $t('apply') }}
                <a-icon style="margin-left: 4px" type="right"/>
              </div>
            </div>
          </div>
        </template>
        <a-empty
            :image="require('../../public/static/icon/search.svg')"
            class="index-price-select-result_empty"
            :imageStyle="{height:'80px'}"
            v-else
        >
          <div style="font-size: 16px;color: #666666;margin-top: 8px;" slot="description">
            <span>{{ $t('NoResultsContactSupport') }}</span>
            <div style="margin-top: 8px;">{{ $t('telSH') }}<span style="margin-left: 6px">{{ $t('telELS') }}</span>
            </div>
          </div>
          <div style="margin-top: 30px">
            <a-space>
              <div class="index-price-select-result_empty_button" @click="gotoApple">
                {{ $t('addBoxApplication') }}
              </div>
            </a-space>
          </div>
        </a-empty>
      </div>

      <!--热门推荐-->
      <a-card class="index-content-promotion" :bodyStyle="{padding:'24px 0'}">
        <div class="index-content-promotion-header">
          <div class="index-content-promotion-header-left">
            <div class="index-content-promotion-header-left-title">{{ $t('cheapest') }}</div>
          </div>
        </div>
<!--        <div class="index-content-promotion-content" v-if="promotionList.length > 0">-->
<!--          <div class="index-content-promotion-content-box" v-for="(item,index) in promotionList" :key="index">-->
<!--            <div class="index-content-promotion-content-box-title">-->
<!--              {{ $dt(item, 'CITY_NAME') }}-->
<!--              <a-icon type="swap-right"/>-->
<!--              {{ $dt(item, 'D_CITY_NAME') }}-->
<!--            </div>-->
<!--            <div class="index-content-promotion-content-box-info-size">-->
<!--              <div class="index-content-promotion-box-info-box">-->
<!--                <div><span class="index-content-promotion-box-info-box-size">{{-->
<!--                    $dt(item, 'BOX_SIZE_NAME')-->
<!--                  }}</span><span class="index-content-promotion-box-info-box-state">{{-->
<!--                    $dt(item, 'BOX_STATE_NAME')-->
<!--                  }}</span></div>-->
<!--                <div class="index-content-promotion-box-info-box-memo"><span>{{ $t('通用_箱量') }}：{{-->
<!--                    Number(item.ROUTE_QTY)-->
<!--                  }}</span></div>-->
<!--              </div>-->
<!--              <div class="index-content-promotion-content-box-info-price">-->
<!--                <div>-->
<!--                  <span>{{ item.VALID_PRICE > 0 ? '' : $t('subsidy') + ' ' }}$</span>-->
<!--                  <span class="index-content-promotion-content-box-info-price-text">-->
<!--                    {{ Math.abs(item.VALID_PRICE) }}-->
<!--                  </span>-->
<!--                </div>-->
<!--                <div>-->
<!--                  <a-button class="index-content-promotion-use-box-btn" :disabled="Number(item.ROUTE_QTY) === 0"-->
<!--                            @click="applyBox(item,20391002)" type="primary">-->
<!--                    {{ $t('apply') }}-->
<!--                  </a-button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--          </div>-->
<!--        </div>-->
<!--        <div v-else>-->
<!--          <a-empty :description="$t('emptyData')"/>-->
<!--        </div>-->
        <index-promotion-list v-if="promotionList.length > 0" :promotionList="promotionList" @applyBox="applyBox"/>
        <div v-else>
          <a-empty :description="$t('emptyData')"/>
        </div>
      </a-card>

      <!--报价表-->
      <a-card v-if="userInfo?.USER_CODE === 'testCargo'" class="index-content-lease" :bodyStyle="{padding:'24px 0'}">
        <div class="index-content-lease-title">
          <div>{{ $t('containerLeasing') }}</div>
        </div>
        <div class="index-content-lease-box">
          <div class="index-content-lease-info-box">
            <div>
              <div class="index-content-lease-prompt">{{ $t('testCargoQuoteHint') }}</div>
              <div class="index-content-lease-news">
                {{ $t('testCargoQuoteContent') }}
              </div>
            </div>
            <a-button class="index-content-lease-btn" @click="$router.push('logon')">{{
                $t('testCargoQuoteButton')
              }}
            </a-button>
          </div>
          <template v-for="item in pointList">
            <div v-if="item.IS_GROUP === '1'" class="index-content-lease-stronghold-else-box">
              <div class="stronghold-title">
                <span class="lease-spot">{{ $dt(item, 'POINT_NAME') }}</span>
              </div>
              <a-row :gutter="24" class="stronghold-spot-box">
                <a-col :span="8" class="lease-spot-area" v-for="nation in item.GM_CITY" :key="nation.NATION_ID">
                  <span class="lease-country">{{ $dt(nation, 'NATION_NAME') }}：</span>
                  <div style="word-break:break-all;">
                    <span v-for="city in nation.CITYS" :key="city.CITY_ID" class="lease-city">{{
                        $dt(city, 'CITY_NAME')
                      }}</span>
                  </div>
                </a-col>
              </a-row>
            </div>
            <div v-else class="index-content-lease-stronghold-box">
              <div class="stronghold-title">
                <span class="lease-spot">{{ $dt(item, 'POINT_NAME') }}</span>
              </div>
              <a-row class="stronghold-spot-box" :gutter="24">
                <a-col :span="6" v-for="city in item.GM_CITY" :key="city.CITY_ID">
                  <div class="lease-spot">{{ $dt(city, 'CITY_NAME') }}</div>
                </a-col>
              </a-row>
            </div>
          </template>
        </div>
      </a-card>
      <a-card v-else class="index-content-lease" :bodyStyle="{padding:'24px 0'}" title="">
        <div class="index-content-lease-title">
          <div>{{ $t('containerLeasing') }}</div>
        </div>
        <div class="index-content-lease-condition">
          <div class="index-content-lease-condition_left">
            <div>
              <a-space :size="24">
                <change-nation :left-nation="nation" :right-nation="rNation" @getNation="getNation"/>
                <div class="index-content-lease-condition_left_city" @click="$refs.priceTable.openSetting()">
                  <div class="index-content-lease-condition_left_city_title">{{ $t('city') }}</div>
                  <div class="index-content-lease-condition_left_city_button">{{ $t('editCity') }}
                    <a-icon style="margin-left: 8px;color: #999999" type="right"/>
                  </div>
                </div>
                <div class="index-content-lease-condition_left_size">
                  <div class="index-content-lease-condition_left_size_title">{{ $t('通用_箱型') }}</div>
                  <a-radio-group
                    class="index-content-lease-condition_left_size_radio_group"
                    v-model.trim="boxSizeRadio"
                    @change="$refs.priceTable.setBoxSize(boxSize)"
                  >
                    <a-radio @click="changeBoxSizeRadio('20GP')" value="20GP">20GP</a-radio>
                    <a-radio @click="changeBoxSizeRadio('40HQ')" value="40HQ">40HQ</a-radio>
                  </a-radio-group>
                </div>
              </a-space>
            </div>
            <div class="index-content-lease-condition_left-box">
              <a-button class="index-content-lease-condition_left-box-button" @click="applyBox({CITY_ID: $refs.priceTable.leftCitySelect[0], D_CITY_ID: $refs.priceTable.topCitySelect[0]},20391004)">{{
                  $t('applyToBox')
                }}
              </a-button>
            </div>
          </div>
          <div class="index-content-lease-condition_left-box-hint">*{{ $t('specialCaseIncluded') }}</div>
        </div>

        <!--报价表-->
        <price-table
          :nation="nation"
          :r-nation="rNation"
          @setBoxSize="size => boxSize = size"
          @gotoApply="(data) => applyBox(data,20391003)"
          ref="priceTable"
        />
      </a-card>

      <!--公告-->
      <a-card class="index-content-bulletin" style="margin-top: 24px;" :title="$t('notice')">
        <div v-if="bulletinList.length > 0">
          <div class="index-content-bulletin-border" v-for="(item,index) in bulletinList" :key="index">
            <div class="index-content-bulletin-content"
                 @click="$router.push(`/bulletinDetail?NOTICE_ID=${item.NOTICE_ID}`)">
              <div class="index-content-bulletin-content-name">{{ $dt(item, 'NOTICE_NAME') }}</div>
              <div class="index-content-bulletin-content-text" v-html="$dt(item,'CONTENT')"></div>
            </div>
            <div class="index-content-bulletin-content-more" @click="$router.push('/bulletin')">{{ $t('more') }}
              <a-icon type="right"/>
            </div>
          </div>
        </div>
        <div v-else>
          <a-empty :description="false"/>
        </div>
      </a-card>
    </div>

    <index-footer></index-footer>
  </div>
</template>

<script>
import IndexHeader from "../components/common/index-header";
import PriceTable from "../components/common/price-table";
import IndexFooter from "../components/common/index-footer";
import changeNation from "@/components/common/changeNation";
import selectBoxSize from "@/components/common/selectBoxSize";
import IndexPromotionList from '@/views/indexComponents/index-promotion-list.vue';

const BOX_SIZE_20GP = 10000008;
const BOX_SIZE_40HQ = 10000012;
const CN_Nation = 10000005;
const RU_Nation = 10000006;

export default {
  name: 'index',
  components: { IndexPromotionList, IndexFooter, PriceTable, IndexHeader, changeNation, selectBoxSize },
  data () {
    return {
      dataInfo: [],
      promotionList: [],
      nation: 10000005,
      rNation: 10000006,
      promotionCityList: [],
      promotionQueryForm: {},
      bulletinList: [],

      boxSize: [],
      BOX_SIZE_20GP,
      BOX_SIZE_40HQ,
      pointList: [],
      value: '',
      quotedPrice: null,
      quotedForm: {
        QUERY_TYPE: 2,
        COMPANY_ID: this.$store.state?.userInfo?.COMPANY_ID,
        RANK_ID: this.$store.state?.userInfo?.RANK_ID,
        NATION: 10000005,
        D_NATION: 10000006,
        CITY_IDS: 10000002,
        D_CITY_IDS: 10000012,
        BOX_SIZE: 10000008,
        IS_LOG: 1
      },
      searchLog: {
        USER_NAME: '',
        MOBILE: ''
      },
      cityList: [],
      boxSizeObj: {}
    };
  },
  computed: {
    boxSizeRadio: {
      get () {
        if (this.boxSize.length === 2) {
          return '';
        } else if (this.boxSize[0] === BOX_SIZE_20GP) {
          return '20GP';
        } else if (this.boxSize[0] === BOX_SIZE_40HQ) {
          return '40HQ';
        }
      },
      set (v) {
        switch (v) {
          case '':
            this.boxSize = [BOX_SIZE_20GP, BOX_SIZE_40HQ];
            break;
          case "20GP":
            this.boxSize = [BOX_SIZE_20GP];
            break;
          case "40HQ":
            this.boxSize = [BOX_SIZE_40HQ];
            break;
        }
      },
    },
    userInfo () {
      return this.$store?.state?.userInfo;
    },
    leftCityOption () {
      let option = [...this.cityList];
      if (!this.quotedForm.D_CITY_ID) {
        return option;
      }
      const rightCityOption = this.cityList.find(i => i.CITY_ID === this.quotedForm.D_CITY_ID);
      // option = option.filter(i => i.NATION !== rightCityOption.NATION);
      option.sort((a, b) => {
        this.sortCity(a, b, rightCityOption);
      });
      return option;
    },
    rightCityOption () {
      let option = [...this.cityList];
      if (!this.quotedForm.CITY_ID) {
        return option;
      }
      const leftCityOption = this.cityList.find(i => i.CITY_ID === this.quotedForm.CITY_ID);
      // option = option.filter(i => i.NATION !== leftCityOption.NATION);
      option.sort((a, b) => {
        this.sortCity(a, b, leftCityOption);
      });
      return option;
    },
  },
  methods: {
    sortCity (a, b, CityOption) {
      if (a.NATION === b.NATION) {
        return a.NUM1 > b.NUM1 ? -1 : 1;
      } else {
        if (CityOption.NATION === CN_Nation) {
          if (a.NATION === RU_Nation) {
            return -1;
          } else if (b.NATION === RU_Nation) {
            return 1;
          } else {
            return a.NATION > b.NATION ? -1 : 1;
          }
        } else if (CityOption.NATION === RU_Nation) {
          if (a.NATION === CN_Nation) {
            return -1;
          } else if (b.NATION === CN_Nation) {
            return 1;
          } else {
            return a.NATION > b.NATION ? -1 : 1;
          }
        }
      }
    },
    gotoPrice () {
      this.$router.push({
        path: '/order/quotationList',
      });
    },
    checkPromotion (data) {
      if (this.promotionQueryForm.CITY_ID === data.CITY_ID) {
        this.promotionQueryForm.CITY_ID = '';
      } else {
        this.promotionQueryForm.CITY_ID = data.CITY_ID;
      }
      this.findPromotion();
    },
    applyBox (data, type) {
      if (this.$store.state?.isVisitor) {
        this.$router.push('/login');
      } else {
        this.$h5Api({
          type: '4101',
          data: [{TARGET_ID: this.userInfo.COMPANY_ID, CITY_ID: data.CITY_ID || '', D_CITY_ID: data.D_CITY_ID || ''}],
        }).then(() => {
          this.$router.push({
            name: 'boxApplyForm',
            params: {
              NATION_ID: data?.NATION_ID || this.nation,
              D_NATION_ID: data?.D_NATION_ID || this.rNation,
              CITY_ID: Number(data?.CITY_ID) || '',
              VALID_PRICE: type === 20391002 ? data.VALID_PRICE : data?.PROM_PRICE
                  ? data?.PROM_PRICE
                  : data.IS_CBC ? 0 : data?.VALID_PRICE,
              D_CITY_ID: Number(data?.D_CITY_ID) || '',
              BOX_SIZE: Number(data?.BOX_SIZE),
              BOX_STATE: Number(data?.BOX_STATE),
              ROUTE_QTY: type === 20391002 ? Number(data.ROUTE_QTY) : data?.PROM_PRICE ? Number(data.ROUTE_QTY) : null,
              BOX_NUM: data?.BOX_NUM,
              SHEET_SRC: type,
            }
          });
        });
      }
    },
    checkNation () {
      let width1 = 400 - 48 - this.$refs.before1.offsetWidth;
      let width2 = 400 - 48 - this.$refs.before2.offsetWidth;
      let width = width1 > width2 ? width2 : width1;
      if (this.isCheck) {
        this.$refs.before1.style = '';
        this.$refs.before2.style = '';
      } else {
        this.$refs.before1.style = `transform: translateX(${width}px)`;
        this.$refs.before2.style = `transform: translateX(-${width}px)`;
      }
      this.isCheck = !this.isCheck;
      let rNation = this.rNation;
      let nation = this.nation;
      this.nation = rNation;
      this.rNation = nation;
    },
    findPromotion () {
      this.$h5Api({
        type: '3021',
        data: [
          {
            QUERY_TYPE: 3,
            COMPANY_ID: this.$store?.state?.userInfo?.COMPANY_ID || '',
            RANK_ID: '',
            CITY_ID: '',
            D_CITY_ID: '',
            BOX_SIZE: '',
            PAGE_SIZE: 999,
            PAGE_INDEX: 1
          }],
        showMessage: false,
      }).then(({ data }) => {
        const promotionList = [];
        data.JT_PRICE_PROM_MASTER.forEach(item => {
          if(item.JT_PRICE_PROM_COMPANY.length === 1 && item.JT_PRICE_PROM_COMPANY[0].VALID_PRICE !== 0){ // 按企业匹配
            item.VALID_PRICE = item.JT_PRICE_PROM_COMPANY[0].VALID_PRICE;
            promotionList.push(item);
          }else if(item.JT_PRICE_PROM_DETAIL.length === 1 && item.JT_PRICE_PROM_DETAIL[0].VALID_PRICE !== 0){ // 按会员等级匹配
            item.VALID_PRICE = item.JT_PRICE_PROM_DETAIL[0].VALID_PRICE;
            promotionList.push(item);
          }
        });
        this.promotionList = promotionList;
      });
    },
    getPromotionCity () {
      this.$h5Api({
        type: '3011',
        data: [
          {
            QUERY_TYPE: "3",
          }],
        showMessage: false,
      }).then(({ data }) => {
        this.promotionCityList = data.JT_PRICE_PROM;
        this.$set(this.promotionQueryForm, 'CITY_ID', this.promotionCityList?.[0]?.CITY_ID);
      });
    },
    getBulletinList () {
      this.$h5Api({
        type: '1001',
        data: [
          this.$dotNetUtil.commonQueryJson('GM_NOTICE', { SYS_TYPE: 20011003 }, 1,
              'NOTICE_ORDER ASC,CREATE_DATE DESC')],
        loading: false,
      }).then(({ data }) => {
        this.bulletinList = data?.DATA_LIST.slice(0, 1);
      });
    },
    getNation (nation, rNation) {
      this.nation = nation;
      this.rNation = rNation;
    },
    getPoints () {
      this.$h5Api({
        type: '2038',
        data: [{}],
        showMessage: false,
      }).then(({ data }) => {
        this.pointList = data.GM_POINT;
        this.pointList?.forEach(item => {
          if (item.IS_GROUP === '1') {
            let nationMap = {};
            item.GM_CITY?.forEach(nation => {
              nationMap[nation.NATION] = {
                NATION: nation.NATION,
                NATION_NAME: nation.NATION_NAME,
                NATION_NAME_ENG: nation.NATION_NAME_ENG,
                NATION_NAME_RUS: nation.NATION_NAME_RUS
              };
              nationMap[nation.NATION].CITYS = [];
            });
            item.GM_CITY?.forEach(CITY => {
              if (nationMap[CITY.NATION]) {
                nationMap[CITY.NATION].CITYS.push(CITY);
              }
            });

            item.GM_CITY = Object.values(nationMap);
          }
        });
      });
    },
    searchPrice () {
      this.$h5Api({
        type: '3001',
        data: [this.quotedForm],
        showMessage: false,
      }).then(({ data }) => {
        let list = data.JT_COMPANY_PRICE.filter(item => !(item.IS_CBC === 0 && item.VALID_PRICE === 0 &&
            (item.PROM_PRICE === 0 || (item.PROM_PRICE !== 0 && !item.ROUTE_QTY))));
        if (list?.length === 0 && this.$store.state?.isVisitor) {
          let leftCityObj = this.leftCityOption.find(item => item.CITY_ID === this.quotedForm.CITY_IDS);
          let rightCityObj = this.rightCityOption.find(item => item.CITY_ID === this.quotedForm.D_CITY_IDS);
          let boxObj = this.$refs.boxSelect.getBoxObj();
          this.quotedPrice = [
            {
              CITY_NAME: leftCityObj.CITY_NAME,
              CITY_NAME_ENG: leftCityObj.CITY_NAME_ENG,
              CITY_NAME_RUS: leftCityObj.CITY_NAME_RUS,
              D_CITY_NAME: rightCityObj.CITY_NAME,
              D_CITY_NAME_ENG: rightCityObj.CITY_NAME_ENG,
              D_CITY_NAME_RUS: rightCityObj.CITY_NAME_RUS,
              BOX_SIZE_NAME: boxObj.CODE_NAME,
              BOX_SIZE_NAME_ENG: boxObj.CODE_NAME_ENG,
              BOX_SIZE_NAME_RUS: boxObj.CODE_NAME_RUS,
              BOX_STATE_NAME: this.boxSizeObj.CODE_NAME,
              BOX_STATE_NAME_ENG: this.boxSizeObj.CODE_NAME_ENG,
              BOX_STATE_NAME_RUS: this.boxSizeObj.CODE_NAME_RUS,
            }];
        } else {
          this.quotedPrice = list;
        }
      });
    },
    submitSearchLog (type) {
      if (type === 2 && !this.searchLog.MOBILE && !this.searchLog.USER_NAME) {
        this.$message.info(this.$t('queryPriceSubmitHint'));
        return true;
      }
      this.$h5Api({
        type: 3015,
        data: [
          {
            LOG_TYPE: type,
            RANK_ID: this.userInfo?.RANK_ID || 10000001,
            CITY_ID: this.quotedForm.CITY_IDS,
            D_CITY_ID: this.quotedForm.D_CITY_IDS,
            BOX_SIZE: this.quotedForm.BOX_SIZE,
            USER_ID: type === 1 ? this.userInfo?.USER_ID : null,
            MOBILE: type === 1 ? this.userInfo?.MOBILE : this.searchLog.MOBILE,
            USER_NAME: type === 1 ? this.userInfo?.USER_NAME : this.searchLog.USER_NAME,
          }],
        showMessage: false,
      }).then(({ data }) => {
        this.searchLog = {};
      });
    },
    gotoApple () {
      this.submitSearchLog(1);
      this.$router.push({
        name: 'boxApplyForm',
        params: {
          NATION_ID: this.quotedForm?.NATION,
          D_NATION_ID: this.quotedForm?.D_NATION,
          CITY_ID: this.quotedForm?.CITY_IDS,
          D_CITY_ID: this.quotedForm?.D_CITY_IDS,
          BOX_SIZE: this.quotedForm?.BOX_SIZE,
        }
      });
    },
    changeCity () {
      let NATION = this.quotedForm.NATION;
      let CITY_ID = this.quotedForm.CITY_IDS;
      let D_NATION = this.quotedForm.D_NATION;
      let D_CITY_ID = this.quotedForm.D_CITY_IDS;
      this.quotedForm.NATION = D_NATION;
      this.quotedForm.CITY_IDS = D_CITY_ID;
      this.quotedForm.D_NATION = NATION;
      this.quotedForm.D_CITY_IDS = CITY_ID;
    },
    changeBoxSizeRadio (size) {
      if (this.boxSizeRadio === size) {
        this.boxSizeRadio = '',
            this.$refs.priceTable.setBoxSize(this.boxSize);
      }
    },
    getCity () {
      this.$h5Api({
        type: '1001',
        data: [this.$dotNetUtil.commonQueryJson('SELECT * FROM GM_CITY', { STATUS: 1 }, 2, '')],
        loading: false,
      }).then(({ data }) => {
        this.cityList = data.DATA_LIST;
        if(this.$route.query.from && this.$route.query.to){
          const fromCity = this.cityList.find(city => city.CITY_ID === Number(this.$route.query.from));
          const toCity = this.cityList.find(city => city.CITY_ID === Number(this.$route.query.to));
          if(fromCity && toCity){
            this.quotedForm.CITY_IDS = fromCity.CITY_ID;
            this.beforeGetData(fromCity.CITY_ID, fromCity, true);
            this.quotedForm.D_CITY_IDS = toCity.CITY_ID;
            this.beforeGetData(toCity.CITY_ID, toCity, false);
            this.$nextTick(() => {
              this.searchPrice();
            });
          }
        }
      });
    },
    beforeGetData (val, data, flag) {
      if (flag) {
        this.$set(this.quotedForm, 'NATION', data?.NATION);
        this.$set(this.quotedForm, 'CITY_NAME', data?.CITY_NAME);
        this.$set(this.quotedForm, 'CITY_NAME_ENG', data?.CITY_NAME_ENG);
        this.$set(this.quotedForm, 'CITY_NAME_RUS', data?.CITY_NAME_RUS);
      } else {
        this.$set(this.quotedForm, 'D_NATION', data?.NATION);
        this.$set(this.quotedForm, 'D_CITY_NAME', data?.CITY_NAME);
        this.$set(this.quotedForm, 'D_CITY_NAME_ENG', data?.CITY_NAME_ENG);
        this.$set(this.quotedForm, 'D_CITY_NAME_RUS', data?.CITY_NAME_RUS);
      }
    },
    getSHX () {
      const sql = `SELECT A.*,B.CODE_NAME_RUS,B.CODE_NAME_ENG,B.CODE_ID,B.CODE_CODE,B.CODE_NAME ,B.IS_VISIBLE IS_DEL FROM BM_BASE_CODE_TYPE A
                       LEFT JOIN BM_BASE_CODE B ON A.TYPE_ID = B.TYPE_ID AND B.STATUS = 1 WHERE A.IS_VISIBLE = 1`;
      const data = [this.$dotNetUtil.commonQueryJson(sql, { TYPE_CODE: '2005', CODE_CODE: 1003 }, 2)];
      this.$h5Api({
        type: '1001',
        data,
      }).then(({ data, message }) => {
        this.boxSizeObj = {
          CODE_NAME: data.DATA_LIST[0].CODE_NAME,
          CODE_NAME_ENG: data.DATA_LIST[0].CODE_NAME_ENG,
          CODE_NAME_RUS: data.DATA_LIST[0].CODE_NAME_RUS,
        };
      });
    }
  },
  created () {
    this.findPromotion();
    this.getPromotionCity();
    this.getBulletinList();
    this.getPoints();
    this.getCity();
    this.getSHX();
  },
};
</script>

<style lang="scss">
.index-page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: #FFFFFF;

  .index-page-select-bg {
    height: 280px;
    width: 100%;
    background: linear-gradient(360deg, #FFFFFF 0%, #F2F7FC 100%);
    position: absolute;
  }

  .index-content {
    width: 1200px;
    margin: 40px auto;

    .index-price-select {
      background: #FFFFFF;
      box-shadow: 0px 6px 20px 0px rgba(15, 54, 93, 0.06);
      border-radius: 6px;
      border: 1px solid #EAEAEA;
      width: 100%;
      padding: 30px 32px 54px 32px;
      position: relative;
      margin-bottom: 72px;

      .index-price-select_title {
        position: relative;
        text-align: center;
        font-size: 24px;
        font-weight: 700;
        color: #1F6CBA;

        .index-price-select_title_button {
          position: absolute;
          right: 0;
          top: 0;
          font-size: 16px;
          font-weight: 400;
          color: #888888;
          margin-top: 6px;
          cursor: pointer;
        }

        .index-price-select_title_button:hover {
          color: #1F6CBA;
        }
      }

      .index-price-select_button {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;

        .index-price-select_button_left {
          display: flex;
          width: 585px;
          background: #FFFFFF;
          box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
          border-radius: 6px;
          border: 1px solid #EEEEEE;
          position: relative;
          padding: 12px 0;

          .index-price-select_button_left_city {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 0 20px;
            border-right: 1px solid #EEEEEE;
            flex: 1;

            .index-price-select_button_left_city_title {
              font-size: 14px;
              font-weight: 400;
              color: #888888;
            }

            .index-price-select_button_left_city_button {
              font-size: 18px;
              font-weight: 600;
              color: #333333;
              margin-top: 6px;
              margin-left: -10px;

              .ant-select-selection {
                border: none;
              }
            }
          }

          .index-price-select_button_left_d_city {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 0 18px;
            flex: 1;

            .index-price-select_button_left_d_city_title {
              font-size: 14px;
              font-weight: 400;
              color: #888888;
            }

            .index-price-select_button_left_d_city_button {
              font-size: 18px;
              font-weight: 600;
              color: #333333;
              margin-top: 6px;
              margin-left: -10px;

              .ant-select-selection {
                border: none;
              }
            }
          }

          .index-price-select_button_img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 40px;
            height: 40px;
          }

        }

        .index-price-select_button_left:hover {
          border-top: 2px solid #1F6CBA;
          padding: 11px 0 12px 0;
        }

        .index-price-select_button_right {
          width: 529px;
          padding: 12px 20px;
          background: #FFFFFF;
          box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
          border-radius: 6px;
          border: 1px solid #EEEEEE;

          .index-price-select_button_right_title {
            font-size: 14px;
            font-weight: 400;
            color: #888888;
            margin-bottom: 5px;
          }

          .index-price-select_button_right_radio.ant-radio-group {
            .ant-radio-inner {
              position: relative;
              top: 0;
              left: 0;
              display: block;
              width: 16px;
              height: 16px;
              background-color: #fff;
              border-color: #d9d9d9;
              border-style: solid;
              border-width: 1px;
              transition: all 0.3s;
              border-radius: 0;
            }

            .ant-radio-checked .ant-radio-inner {
              background-color: #1890ff;
            }

            .ant-radio-inner:after {
              position: absolute;
              top: 50%;
              left: 22%;
              display: table;
              width: 5.71428571px;
              height: 9.14285714px;
              border: 2px solid #fff;
              border-top: 0;
              border-left: 0;
              transform: rotate(45deg) scale(0) translate(-50%, -50%);
              opacity: 0;
              transition: all .1s cubic-bezier(.71, -.46, .88, .6), opacity .1s;
              content: " ";
              border-radius: 0;
              background-color: transparent;
            }

            .ant-radio-checked .ant-radio-inner:after {
              position: absolute;
              display: table;
              border: 2px solid #fff;
              border-top: 0;
              border-left: 0;
              transform: rotate(45deg) scale(1) translate(-50%, -50%);
              opacity: 1;
              transition: all .2s cubic-bezier(.12, .4, .29, 1.46) .1s;
              content: " ";
            }
          }
        }

        .index-price-select_button_right:hover {
          padding: 11px 20px 12px 20px;
          border-top: 2px solid #1F6CBA;
        }
      }

      .index-price-select_submit_button {
        cursor: pointer;
        padding: 16px 48px;
        background: linear-gradient(137deg, #51A4FA 0%, #1F7EE0 100%);
        border-radius: 32px;
        position: absolute;
        bottom: -30px;
        font-size: 20px;
        font-weight: 600;
        color: #FFFFFF;
        box-shadow: 0 2px 12px 0 rgba(22, 82, 144, 0.35);
        left: 43%;
        transition: all 0.5s;
      }

      .index-price-select_submit_button:hover {
        transform: scale(1.05);
      }
    }

    .index-price-select-result {
      margin-top: 74px;
      margin-bottom: 48px;

      .index-price-select-result_title {
        margin-bottom: 20px;
        font-size: 20px;
        font-weight: 600;
        color: #333333;

        span {
          padding-left: 12px;
          font-size: 14px;
          color: #666666;
          font-weight: 400;
        }
      }

      .index-price-select-result_box {
        background: #FFFFFF;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
        border-radius: 6px;
        border: 1px solid #EAEAEA;
        display: flex;
        justify-content: space-between;

        .index-price-select-result_box_img {
          width: 87px;
          height: 87px;
        }

        .index-price-select-result_box_content {
          margin-left: 42px;
          flex: 1;

          .index-price-select-result_box_content_col {
            height: 100%;
            display: flex;

            .index-price-select-result_box_content_col_svg {
              display: flex;
              align-items: center;
              height: 100%;
            }

            .index-price-select-result_box_content_col_city {
              font-size: 16px;
              font-weight: 600;
              color: #333333;
              display: flex;
              justify-content: space-between;
              flex-direction: column;
              padding: 12px 0;
              margin-left: 18px;
            }

            .index-price-select-result_box_content_col_2 {
              padding: 16px 0;
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .index-price-select-result_box_content_col_2_top {
                color: #999999;
              }

              .index-price-select-result_box_content_col_2_bottom {
                font-size: 16px;
                color: #333333
              }
            }

            .index-price-select-result_box_content_col_4 {
              padding: 16px 0 11px 0;
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .index-price-select-result_box_content_col_4_top {
                color: #999999;
              }

              .index-price-select-result_box_content_col_4_bottom {
                font-size: 20px;
                font-weight: 600;
                color: #FF680B;
              }

              .index-price-select-result_box_content_col_4_hide {
                font-size: 16px;
                font-weight: 600;
              }
            }
          }
        }

        .index-price-select-result_box_button {
          display: flex;
          justify-content: center;
          align-items: center;

          .index-price-select-result_box_button_style {
            margin-right: 40px;
            padding: 8px 20px;
            background: linear-gradient(51deg, #FEA43A 0%, #FF7800 100%);
            border-radius: 4px;
            cursor: pointer;
            font-weight: 600;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            transition: all 0.5s;
          }

          .index-price-select-result_box_button_style:hover {
            transform: scale(1.1);

            box-shadow: 0px 2px 12px 0px rgba(255, 228, 204, 0.25);
          }
        }

        + .index-price-select-result_box {
          margin-top: 12px;
        }
      }

      .index-price-select-result_empty.ant-empty {
        padding: 48px 0;
        background: #F9F9F9;
        margin: 0;

        .index-price-select-result_empty_button {
          background: linear-gradient(51deg, #FEA43A 0%, #FF7800 100%);
          border-radius: 4px;
          font-size: 18px;
          font-weight: 600;
          color: #FFFFFF;
          padding: 10px 20px;
          cursor: pointer;
        }

        .index-price-select-result_empty_button:hover {
          transform: scale(1.05);
        }
      }
    }

    .index-content-menu {
      display: flex;
      flex-direction: row;
      width: 100%;
      margin-top: 26px;

      .index-content-menu-border {
        flex: 1;
        background: #FFFFFF;
        box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.1000);
        border-radius: 6px;
        padding: 15px 20px 18px 20px;

        + .index-content-menu-border {
          margin-left: 24px;
        }

        .index-content-menu-title {
          font-size: 20px;
          font-weight: 600;
          color: #1F6CBA;
          line-height: 28px;

          img {
            width: 25px;
            height: 25px;
          }

          span {
            margin-left: 4px;
          }
        }

        .index-content-menu-text {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          line-height: 20px;
          margin-top: 10px;
        }
      }
    }

    .index-content-bulletin {
      border: 1px solid #DDDDDD;

      .index-content-bulletin-border {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .index-content-bulletin-content {
          cursor: pointer;
          flex: 1;

          .index-content-bulletin-content-name {
            font-weight: 700;
            font-size: 16px;
            max-width: 900px;
          }

          .index-content-bulletin-content-text {
            line-height: 1;
            margin-top: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            max-width: 900px;
          }
        }

        .index-content-bulletin-content-more {
          cursor: pointer;
          width: 80px;
          text-align: right;
        }

        .index-content-bulletin-content-more:hover {
          color: #1F6CBA;
        }
      }

      .index-header-content_right {
        display: flex;
        flex: 1;
        justify-content: space-around;
        margin-left: 48px;

        span {
          font-size: 12px;
          color: #FFFFFF;
          line-height: 17px;
          white-space: nowrap;

          span {
            font-size: 28px;
            font-weight: 700;
            color: #FFFFFF;
            line-height: 40px;
            margin-left: 15px;
          }
        }
      }
    }

    .index-content-lease {
      margin-top: 24px;

      .index-content-lease-title {
        margin-bottom: 6px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-left: 4px solid #1C62A9;
        padding-left: 12px;
        font-size: 26px;
        font-weight: 600;
        color: #333333;
        line-height: 1;

        .index-content-lease-title-right {
          font-size: 16px;
        }
      }

      .index-content-lease-condition {
        display: flex;
        justify-content: space-between;
        flex-direction: column;

        .index-content-lease-condition_left {
          margin-top: 24px;
          justify-content: space-between;
          display: flex;
          align-items: center;
          width: 100%;

          .index-content-lease-condition_left-box {
            display: flex;
            align-items: flex-end;
            flex-direction: column;
            align-items: center;

            .index-content-lease-condition_left-box-button {
              padding: 10px 20px 30px 20px;
              border-radius: 6px;
              border: 1px solid #1F6CBA;
              font-size: 16px;
              font-weight: 500;
              color: #1F6CBA;
              cursor: pointer;
            }

            .index-content-lease-condition_left-box-button:hover {
              color: #FFFFFF;
              background: #1F6CBA;
            }
          }


          .index-content-lease_border {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 450px;
            border-radius: 4px 4px 0px 0px;
            border: 1px solid #DDDDDD;
            padding: 10px 24px;

            .index-content-lease_icon {
              cursor: pointer;
              font-size: 20px;
            }

            .index-content-lease_right {
              text-align: right;
            }

            .index-content-lease_city-title {
              font-size: 12px;
              font-weight: 400;
              color: #9FA9B3;
              line-height: 17px;
            }

            .index-content-lease_city-name {
              font-size: 18px;
              color: #484747;
              line-height: 25px;
              transition: transform 1s;
              max-width: 100px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              cursor: pointer;
              font-weight: 700;
            }
          }

          .index-header-content {
            margin-left: 24px;
            height: 68px;
            background: #FFFFFF;
            margin-top: auto;
            padding: 10px 0;
            display: flex;
            justify-content: center;
            align-items: center;

          }

          .index-content-lease_message {
            margin-left: 24px;

            div {
              font-size: 12px;
              font-weight: 400;
              color: #999999;
              line-height: 17px;
              letter-spacing: 0.5px;
              padding: 3px 0;
            }
          }

          .index-content-lease-condition_left_size {
            padding: 10px 20px 11px 20px;
            border-radius: 6px;
            border: 1px solid #EEEEEE;

            .index-content-lease-condition_left_size_title {
              color: #888888;
              margin-bottom: 5px;
            }

            .index-content-lease-condition_left_size_radio_group.ant-radio-group {
              display: flex;

              .ant-radio-inner {
                position: relative;
                top: 0;
                left: 0;
                display: block;
                width: 16px;
                height: 16px;
                background-color: #fff;
                border-color: #d9d9d9;
                border-style: solid;
                border-width: 1px;
                transition: all 0.3s;
                border-radius: 0;
              }

              .ant-radio-checked .ant-radio-inner {
                background-color: #1890ff;
              }

              .ant-radio-inner:after {
                position: absolute;
                top: 50%;
                left: 22%;
                display: table;
                width: 5.71428571px;
                height: 9.14285714px;
                border: 2px solid #fff;
                border-top: 0;
                border-left: 0;
                transform: rotate(45deg) scale(0) translate(-50%, -50%);
                opacity: 0;
                transition: all .1s cubic-bezier(.71, -.46, .88, .6), opacity .1s;
                content: " ";
                border-radius: 0;
                background-color: transparent;
              }

              .ant-radio-checked .ant-radio-inner:after {
                position: absolute;
                display: table;
                border: 2px solid #fff;
                border-top: 0;
                border-left: 0;
                transform: rotate(45deg) scale(1) translate(-50%, -50%);
                opacity: 1;
                transition: all .2s cubic-bezier(.12, .4, .29, 1.46) .1s;
                content: " ";
              }

              .default-radio-option {
                line-height: 40px;
              }

              .more-radio-option {
                line-height: 40px;
                display: flex;
                align-items: center;

              }
            }

          }

          .index-content-lease-condition_left_city {
            padding: 10px 20px 11px 20px;
            border-radius: 6px;
            border: 1px solid #EEEEEE;
            min-width: 187px;
            cursor: pointer;

            .index-content-lease-condition_left_city_title {
              color: #888888;
              margin-bottom: 5px;
            }

            .index-content-lease-condition_left_city_button {
              font-weight: 400;
              color: #666666;
            }
          }
        }

        .index-content-lease-condition_left-box-hint {
          font-size: 12px;
          color: #bbbbbb;
          margin-top: 24px;
        }
      }

      .index-content-lease-box {
        background-color: rgba(245, 247, 249, 0.5);
        padding: 24px;
        margin-top: 24px;
        border-radius: 5px;
        display: flex;
        flex-direction: column;

        .index-content-lease-info-box {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .index-content-lease-prompt {
            font-weight: 600;
            color: #333333;
            font-size: 16px;
          }

          .index-content-lease-news {
            margin-top: 12px;
            font-weight: 400;
            color: #999999;
            font-size: 14px;
          }

          .index-content-lease-btn {
            margin-left: 40px;
            font-size: 16px;
            padding: 12px 16px 34px;
            background-color: #1F6CBA;
            border-radius: 5px;
            border: 1px solid #1F6CBA;
            font-weight: 400;
            color: #FFFFFF;
            text-align: center;
            transition: all 0.5s;
          }

          .index-content-lease-btn:hover {
            transform: scale(1.05);

          }
        }

        .index-content-lease-stronghold-box {
          margin-top: 20px;
          padding: 12px 24px;
          display: flex;
          border: 1px solid rgba(31, 108, 186, 0.2);
          border-radius: 5px;

          .stronghold-title {
            width: 160px;

            .lease-spot {
              font-size: 14px;
              font-weight: 600;
              color: #333333;
              cursor: pointer;
            }
          }

          .stronghold-spot-box {
            width: 100%;
            margin-top: -12px;

            .lease-spot {
              font-weight: 400;
              color: #666666;
              font-size: 14px;
              cursor: pointer;
              margin-top: 12px;
            }

          }

        }

        .index-content-lease-stronghold-else-box {
          margin-top: 20px;
          padding: 12px 24px;
          display: flex;
          border: 1px solid rgba(31, 108, 186, 0.2);
          border-radius: 5px;

          .stronghold-title {
            width: 160px;

            .lease-spot {
              font-size: 14px;
              font-weight: 600;
              color: #333333;

            }

          }

          .stronghold-spot-box {
            width: 100%;
            margin-top: -12px;

            .lease-spot-area {
              display: flex;
              font-weight: 400;
              color: #666666;
              font-size: 14px;
              word-break: break-all;
              margin-top: 12px;

              .lease-country {
                font-size: 14px;
                font-weight: 400;
                color: #2F71B4;
                cursor: pointer;
                white-space: nowrap;
              }

              .lease-city {
                font-size: 14px;
                font-weight: 400;
                color: #666666;
                cursor: pointer;
                padding-left: 12px;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }

    .index-content-promotion {
      margin-top: 24px;

      .index-content-promotion-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0 24px 6px;

        .index-content-promotion-header-left {
          display: flex;

          .index-content-promotion-header-left-title {
            border-left: 4px solid #1C62A9;
            padding-left: 12px;
            white-space: nowrap;
            font-size: 26px;
            font-weight: 600;
            color: #333333;
            line-height: 1;
          }

          .index-content-promotion-header-left-city {
            margin-left: 61px;
            display: flex;
            align-items: center;

            .index-content-promotion_query-title {
              font-size: 14px;
              white-space: nowrap;
              font-weight: 400;
              color: #999999;
              line-height: 20px;
            }

            .query-content {
              cursor: pointer;
              padding: 8px 16px;
              margin: 0 16px;
            }

            .check-content {
              cursor: pointer;
              background: #EBF3FA;
              color: #1F6CBA;
              padding: 8px 16px;
              margin: 0 16px;
              border-radius: 4px;
            }
          }
        }

        .index-content-promotion-header-right {
          font-size: 16px;
        }
      }
    }

    .index-content-deal {
      margin-top: 24px;
      position: relative;

      .index-content-carousel-left-circle {
        position: absolute;
        top: 210px;
        left: 0;
        z-index: 999;
        font-size: 20px;
        color: #666666;
      }

      .index-content-carousel-right-circle {
        position: absolute;
        top: 210px;
        right: 0px;
        z-index: 999;
        font-size: 20px;
        color: #666666;
      }

      .index-content-deal-title {
        display: flex;
        justify-content: space-between;

        .index-content-deal-title-left {
          border-left: 4px solid #1C62A9;
          padding-left: 12px;
          font-size: 26px;
          font-weight: 600;
          color: #333333;
          line-height: 1;
        }

        .index-content-deal-title-right {
          font-size: 16px;
          color: #1F6CBA;
        }
      }

      .index-content-deal-content-box {
        width: 217px !important;
        height: 366px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #DDDDDD;
        margin: 0 8px;

        img {
          width: 217px;
          height: 217px;
          object-fit: cover;
          border-radius: 4px;
          margin-left: -1px;
        }

        .index-content-deal-content-title {
          font-size: 16px;
          font-weight: 600;
          color: #333333;
          margin-top: 10px;
        }

        .index-content-deal-content-num {
          color: #666666;
          margin-top: 6px;
        }

        .index-content-deal-content-price {
          display: flex;
          align-items: center;

          span {
            font-size: 20px;
            font-weight: 600;
          }
        }
      }

      .index-content-deal-content-box:hover {
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
      }
    }
  }
}
</style>

